import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/03/25/principle/absorbing-ceiling-panels.svg`,
        },
      },
    },
  },
];

export default components;
